import { Button } from "react-daisyui"
import PortalPopup from "./portal-popup"

type ModalType = {
  id: string
  headerIcon?: string
  title: string
  children?: JSX.Element
  okButton?: {
    onClick: () => void
    name: string
  }
  open: boolean
  onClose?: () => void
}

const Modal = ({
  id,
  title,
  headerIcon = "/v3/assets/featured_icon.svg",
  children,
  okButton,
  open,
  onClose,
}: ModalType) => {
  if (!open) return null
  return (
    <PortalPopup
      overlayColor="rgba(113, 113, 113, 0.3)"
      placement="Centered"
      onOutsideClick={onClose}>
      <div id={`close-modal-${id}`} onClick={onClose}></div>
      <div
        id={id}
        className="relative rounded-xl bg-base-white shadow-[0px_20px_24px_-4px_rgba(16,_24,_40,_0.08),_0px_8px_8px_-4px_rgba(16,_24,_40,_0.03)] min-w-[300px] max-w-full md:max-w-[400px] overflow-hidden flex flex-col items-center justify-start  max-h-full text-left text-gray-900 font-text-md-regular p-6">
        <div className="self-stretch bg-base-white flex flex-col items-center justify-start relative">
          <div className="self-stretch bg-base-white flex flex-col items-start justify-start gap-[16px] z-[0]">
            {/*
            we should use icon as react svg component instead of img tag to be able to change the color of the icon and have a better control over it

            <img
              className="relative rounded-full w-8 h-8 bg-blue-light-200 p-3 fill-blue-light-600 text-blue-light-600"
              alt={headerIcon}
              src={headerIcon}
            /> */}
            <img
              className="relative rounded-full w-14 h-14"
              alt=""
              src={headerIcon}
            />
            <div className="self-stretch flex flex-col items-start justify-start gap-[4px]">
              <div className="self-stretch relative leading-[28px] font-semibold text-lg">
                {title}
              </div>
              <div className="self-stretch relative text-sm leading-[24px] text-gray-600">
                {children}
              </div>
            </div>
          </div>
          {/* <div className="my-0 mx-[!important] absolute top-[16px] right-[16px] rounded-lg overflow-hidden flex flex-row items-center justify-center p-2.5 z-[1]">
            <img
              className="relative w-6 h-6 overflow-hidden shrink-0"
              alt=""
              src="/v3/assets/x-close.svg"
            />
          </div> */}
          {okButton && (
            <div className="pt-8 w-full">
              <Button
                color="info"
                size="sm"
                onClick={okButton.onClick}
                className="w-full bg-blue-light-600 text-white h-[38px]">
                {okButton.name}
              </Button>
            </div>
          )}
        </div>
      </div>
    </PortalPopup>
  )
}

export default Modal
